import { tabsReducer } from '../../../redux/resources/tabs';
import { userReducer } from '../../../redux/resources/user';

export const reducers = {
  user: userReducer,
  tabs: tabsReducer,
};
